import { Directive, HostListener, ElementRef, HostBinding } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appUpperCase]'
})
export class AppUpperCaseDirective extends AppAbstractDirective {

  constructor(private element: ElementRef) {
    super();
  }

  @HostBinding('class')
  elementClass = 'upperCase';
/*
  @HostListener('input') onInput(): void {
    this.element.nativeElement.value = this.element.nativeElement.value.toUpperCase();
  }
*/
  @HostListener('focus') onFocus(): void {
    this.element.nativeElement.select();
  }

}
